export default {"src":"/_next/static/media/Osteoporosis.0602d14c.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};